<button
  class="btn shadow-none border-none"
  [disabled]="disabledFlag"
  (click)="btnAction()"
>
  <app-svg-icon icon="pencil-edit" color="#bdbdbd" padding="8px"></app-svg-icon>
</button>
